module.exports = __webpack_public_path__ + "static/img/chart_title1.a8312f56.png";